import React, { FunctionComponent, useContext } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { AppContext } from "../app/store";
import { hasGlobalSession, useUrlWithSearchParams } from "../helpers";

const PrivateRoute: FunctionComponent<RouteProps> = ({ children, ...rest }) => {
  const { state } = useContext(AppContext);
  const redirect = useUrlWithSearchParams("/");

  if (hasGlobalSession(state)) {
    return <Route {...rest}>{children}</Route>;
  }
  // Not authenticated, no bene, go to landing
  return <Redirect to={redirect} />;
};

export default PrivateRoute;
